import { render, staticRenderFns } from "./LotsSupplyingG.vue?vue&type=template&id=5bc1b4cc"
import script from "./LotsSupplyingG.vue?vue&type=script&lang=js"
export * from "./LotsSupplyingG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports